import { Box, Stack } from "@mui/material";
import { DashboardLayout, ThemeSwitcher } from "@toolpad/core/DashboardLayout";
import { SyncMetadataWidget } from "../components/SyncMetadataWidget";
import UserProfile from "../components/UserProfile";

export function AppDashboardLayout({
  children,
}: {
  children?: React.ReactNode;
}) {
  return (
    <DashboardLayout
      defaultSidebarCollapsed={true}
      slots={{
        toolbarAccount: UserProfile,
        toolbarActions: () => (
          <Stack direction="row" spacing={1} alignItems={"center"}>
            <SyncMetadataWidget />
            <ThemeSwitcher />
          </Stack>
        ),
      }}
    >
      <Box
        padding={"8px"}
        maxWidth={"100%"}
        maxHeight={"100%"}
        overflow={"hidden"}
      >
        {children}
      </Box>
    </DashboardLayout>
  );
}
